import {getParent, matchElement} from "../../../utils/queries/index.js";
import {LI_TYPE} from "../../../utils/constants.js";
export const isListNested = (editor, listPath) => {
  const listParentNode = getParent(editor, listPath)?.[0];
  return !!listParentNode && matchElement(LI_TYPE)(listParentNode);
};
